// Route → allowed roles. Mirrors the sidebar `roles` in DashboardLayout so a
// direct URL to a page the user can't see in the nav renders the RoleGate
// "Not authorised" panel instead of a page shell full of 403 errors.
// Pages reachable from shared widgets (bell, portals, deep-links) are omitted
// on purpose — they stay open to every authenticated role.
const FIN = ['admin', 'finance'];
const FIN_AUDIT = ['admin', 'finance', 'auditor'];

export const ROUTE_ROLES = {
  'company/settings': ['admin'],
  'company/locations': ['admin'],
  'company/documents': ['admin', 'auditor'],
  'compliance-reports': ['admin', 'auditor'],
  staff: ['admin'],
  users: ['admin'],
  'users/linkage-health': ['admin'],
  'audit-logs': ['admin', 'auditor'],
  programs: ['admin', 'instructor', 'auditor'],
  students: ['admin', 'instructor', 'partner_instructor', 'finance'],
  'student-progress': ['admin', 'instructor'],
  exams: ['admin', 'instructor'],
  'skill-tests': ['admin', 'instructor', 'auditor'],
  aircraft: ['admin', 'instructor', 'auditor'],
  maintenance: ['admin', 'instructor', 'auditor'],
  safety: ['admin', 'instructor', 'auditor'],
  'aviation-reports': ['admin', 'auditor'],
  billing: ['admin', 'finance', 'student'],
  payroll: FIN,
  procurement: FIN,
  reports: FIN_AUDIT,
  integrations: ['admin'],
  'my-portal': ['student'],
  'instructor-portal': ['instructor', 'admin'],
  analytics: FIN,
  'finance-reports': FIN,
  'finance-home': FIN,
  debrief: ['admin', 'instructor'],
  'training-records': ['admin', 'instructor', 'student', 'auditor'],
  'auto-scheduler': ['admin', 'instructor'],
  utilization: ['admin', 'instructor', 'auditor'],
  'operations-board': ['admin', 'instructor', 'auditor'],
  'payment-plans': FIN,
  expenses: FIN,
  revenue: FIN,
  budgets: FIN,
  'vat-reports': FIN_AUDIT,
  crm: ['admin', 'finance'],
  batches: ['admin', 'instructor'],
  'batch-timetable': ['admin', 'instructor'],
  violations: ['admin', 'instructor'],
  'student-finance': FIN,
  'flight-dispatch': ['admin', 'instructor', 'partner_instructor'],
  'medical-alerts': ['admin', 'instructor'],
  'document-expiry': ['admin', 'auditor'],
  security: ['admin'],
  vendors: FIN,
  leaves: FIN,
  absences: ['admin'],
  'academic-lifecycle': ['admin', 'instructor', 'auditor'],
  contracts: FIN,
  'salary-scale': FIN,
  'reports-dashboard': FIN_AUDIT,
  'income-statement': FIN_AUDIT,
  departments: ['admin'],
  'data-cleanup': ['admin'],
  'admin/data-tools': ['admin'],
};
